
export default {
	props: {
		pull: {
			type: Boolean,
			default: false,
		},
	},
}
